"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithModelFeature = void 0;
var foundation_1 = require("@deqo/foundation");
var ModelMutation_1 = require("./ModelMutation");
var ModelOperation_1 = require("./ModelOperation");
var ModelRepository_1 = require("./ModelRepository");
var ModelRequests_1 = require("./ModelRequests");
var ModelTransaction_1 = require("./ModelTransaction");
var ModelTypes_1 = require("./ModelTypes");
var logger = foundation_1.Logger.get('podopolis.model');
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function WithModelFeature(Base) {
    return /** @class */ (function (_super) {
        __extends(ModelFeature, _super);
        function ModelFeature() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spreadArray([], __read(args), false)) || this;
            _this.currentTime = -1;
            _this.mutation = null;
            _this.minResponseTimeout = null;
            // private txConfirmed: ModelTransaction[] = [];
            _this.txDeltas = [];
            _this.txPending = null;
            _this.txStaged = [];
            _this.inNotifyTransaction = function (data) {
                if (_this.destroyed())
                    return;
                // If model initialized, apply...
                if (_this.model) {
                    // Unpack the d eight a
                    var tx = ModelTransaction_1.ModelTransaction.unpack(data);
                    // TODO: fucking validate the versions but this needs to be from the server as well i think
                    _this.model.applyConfirmedWrites(tx.version, tx.writes);
                    _this.currentTime = Math.max(_this.currentTime, tx.time);
                    _this.router.emit('modelMutation', ['remote', {
                            applyBatch: tx.writes,
                            writeSet: ModelOperation_1.ModelOperation.entities(tx.writes),
                        }]);
                    // Any pending or staged changes will need rebasing
                    // this.rebaseUnconfirmedChanges();
                }
                // If not, store in temp list until initialized
                else {
                    _this.txDeltas.push(data);
                }
            };
            _this.pod.receive('notify_tx', _this.inNotifyTransaction);
            _this.onInit(_this.modelStart);
            return _this;
        }
        ModelFeature.prototype.getMutation = function () {
            return this.mutation || null;
        };
        ModelFeature.prototype.getModel = function () {
            return this.model;
        };
        ModelFeature.prototype.getTime = function () {
            return this.currentTime;
        };
        ModelFeature.prototype.mutate = function (impl) {
            var _a;
            if (this.destroyed())
                return false;
            (0, foundation_1.assert)(!this.mutation, 'PodSession: mutation already in progress.');
            try {
                // Create and perform the mutation
                var mutation = this.mutation = new ModelMutation_1.ModelMutation(this.model, this.router);
                var data = mutation.perform(impl);
                // If null OR we didn't actually perform any changes, return false to indicate cancellation.
                if (!data || !data.applyBatch.length) {
                    return false;
                }
                // Create the staged transaction record
                var stx = ModelTransaction_1.ModelTransaction.createStaged(data.key, this.currentTime + 1, (_a = data.mode) !== null && _a !== void 0 ? _a : 1, /* Deprecated readSet array: */ [], data.applyBatch);
                // Stage the transaction
                this.txStaged.push(stx);
                // Update current time
                this.currentTime = stx.time;
                // Release the mutation
                this.mutation = null;
                // If there is no txPending, kick off the submit function
                if (!this.txPending) {
                    if (!this.readonly) {
                        void (this.submitStaged());
                    }
                }
                // Push and return true to indicate accepted.
                this.router.emit('modelMutation', ['local', data]);
                return true;
            }
            finally {
                this.mutation = null;
            }
        };
        ModelFeature.prototype.on = function (type, to) {
            return this.router.on(type, to);
        };
        ModelFeature.prototype.modelStart = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.initModel()];
                        case 1:
                            _a.sent();
                            logger.log('Started model feature with:');
                            logger.log('Time:', this.currentTime, 'Version:', this.model.getVersion());
                            return [2 /*return*/];
                    }
                });
            });
        };
        ModelFeature.prototype.initModel = function () {
            return __awaiter(this, void 0, void 0, function () {
                var snapshot, store, deltas, deltas_1, deltas_1_1, ctx;
                var e_1, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            logger.log('Intitalizing model');
                            // Subscribe to pod model updates
                            return [4 /*yield*/, this.pod.request((0, ModelRequests_1.subscribeModel)())];
                        case 1:
                            // Subscribe to pod model updates
                            _b.sent();
                            return [4 /*yield*/, this.pod.request((0, ModelRequests_1.fetchModel)())];
                        case 2:
                            snapshot = _b.sent();
                            store = ModelTypes_1.ModelSnapshot.convert(snapshot);
                            // Assuming we subscribed successfully, assign the neccesary properties to the session
                            this.currentTime = snapshot.time;
                            this.model = new ModelRepository_1.ModelRepository(store);
                            deltas = this.txDeltas.splice(0, this.txDeltas.length);
                            try {
                                for (deltas_1 = __values(deltas), deltas_1_1 = deltas_1.next(); !deltas_1_1.done; deltas_1_1 = deltas_1.next()) {
                                    ctx = deltas_1_1.value;
                                    if (this.model.getVersion() < ctx[2]) {
                                        this.inNotifyTransaction(ctx);
                                    }
                                    else {
                                        logger.warn("Ignoring delta with version ".concat(ctx[2], " as model already at ").concat(this.model.getVersion()));
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (deltas_1_1 && !deltas_1_1.done && (_a = deltas_1.return)) _a.call(deltas_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        ModelFeature.prototype.submitStaged = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, accepted, newVersion, e_2;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.txStaged.length) return [3 /*break*/, 5];
                            if (this.destroyed())
                                return [2 /*return*/];
                            // if (Debug.pauseOnProcessBuffer) {
                            //     debugger;
                            // }
                            // Produce a single pending optimized transaction from the txStaged queue (and clear the queue)
                            // Profiler.enter('PodSession.txStagedMerge');
                            this.txPending = ModelTransaction_1.ModelTransaction.createPending(this.txStaged.splice(0, this.txStaged.length));
                            // .optimize();
                            // Profiler.exit('PodSession.txStagedMerge');
                            // Promote the staging buffer to the pending buffer within the model repo
                            this.model.promoteStagingToPending();
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            // Set min response time timer
                            if (this.minResponseTimeout)
                                clearTimeout(this.minResponseTimeout);
                            this.minResponseTimeout = setTimeout(function () {
                                // Handle error behavior here
                                _this.destroy('model:timeout');
                            }, 1000 * 10);
                            return [4 /*yield*/, this.pod.request((0, ModelRequests_1.submitTransaction)(this.txPending.pack()))];
                        case 2:
                            _a = __read.apply(void 0, [_b.sent(), 2]), accepted = _a[0], newVersion = _a[1];
                            logger.log('Accepted:', accepted, 'Version now:', newVersion);
                            // Clear response timer
                            clearTimeout(this.minResponseTimeout);
                            this.minResponseTimeout = null;
                            if (accepted) {
                                // If accepted, create confirmed transaction and add to log
                                // this.txConfirmed.push(ModelTransaction.createConfirmed(this.txPending, newVersion));
                                // Promote the pending buffer within the model repo (pass new version of committed state)
                                this.model.promotePendingToConfirmed(newVersion);
                            }
                            else {
                                // Handle error behavior here
                                this.destroy('model:rejection');
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            e_2 = _b.sent();
                            // eslint-disable-next-line no-console
                            console.error(e_2);
                            return [3 /*break*/, 4];
                        case 4:
                            // Clear the pending transaction
                            this.txPending = null;
                            // Recurse in case there is more now...
                            void (this.submitStaged());
                            return [3 /*break*/, 0];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        return ModelFeature;
    }(Base));
}
exports.WithModelFeature = WithModelFeature;
